import { CoverageCampaignEditor } from "@/components/coverage/CoverageCampaignEditor";
import { CoverageLookupCard } from "@/components/coverage/CoverageLookupCard";
import { CoverageMap } from "@/components/coverage/CoverageMap";
import { CoverageNotesPanel } from "@/components/coverage/CoverageNotesPanel";
import { CoveragePartyEditor } from "@/components/coverage/CoveragePartyEditor";
import { CoverageProblems } from "@/components/coverage/CoverageProblems";
import { useCoverageBoard } from "@/components/coverage/useCoverageBoard";

export function CoverageAssistantPanel() {
  const board = useCoverageBoard();
  return (
    <div className="flex h-full min-h-[640px] flex-col gap-3 p-3 lg:flex-row">
      <div className="flex w-full flex-col gap-3 lg:w-96 lg:shrink-0">
        {board.loadError ? <p className="text-sm text-red-600">{board.loadError}</p> : null}
        <CoverageProblems problems={board.problems} />
        <CoverageLookupCard
          address={board.address}
          program={board.program}
          sizeLabel={board.sizeLabel}
          busy={board.lookupBusy}
          error={board.lookupError}
          precision={board.precision}
          point={board.point}
          hits={board.hits}
          suggestion={board.suggestion}
          suggestBusy={board.suggestBusy}
          suggestError={board.suggestError}
          chosenPartyId={board.chosenPartyId}
          onAddress={board.setAddress}
          onProgram={board.setProgram}
          onSizeLabel={board.setSizeLabel}
          onLookup={() => void board.lookup()}
          onSuggest={() => void board.suggest()}
          onChoose={board.chooseParty}
        />
        <CoveragePartyEditor
          parties={board.parties}
          areas={board.areas}
          draft={board.draft}
          busy={board.saving}
          error={board.saveError}
          drawing={board.drawing}
          onChange={board.setDraft}
          onSelect={board.selectParty}
          onSave={() => void board.save()}
          onDraw={() => {
            board.setCampaignDrawing(false);
            board.setDrawing(true);
          }}
        />
        <CoverageNotesPanel
          partyId={board.draft.id}
          program={board.program}
          sizeLabel={board.sizeLabel}
          notes={board.notes}
          busy={board.noteBusy}
          error={board.noteError}
          onSave={(input) => void board.saveNote(input)}
          onInvalidate={(id) => void board.invalidateNote(id)}
          onReconfirm={(id) => void board.reconfirmNote(id)}
        />
        <CoverageCampaignEditor
          campaigns={board.campaigns}
          polygon={board.campaignPolygon}
          drawing={board.campaignDrawing}
          showCampaigns={board.showCampaigns}
          onShowCampaigns={board.setShowCampaigns}
          onDraw={() => {
            board.setDrawing(false);
            board.setCampaignDrawing(true);
          }}
          onSaved={() => {
            board.clearCampaignPolygon();
            void board.reload();
          }}
        />
      </div>
      <div className="min-h-[420px] flex-1">
        <CoverageMap
          parties={board.parties}
          areas={board.areas}
          campaigns={board.campaigns}
          showCampaigns={board.showCampaigns}
          locations={board.locations}
          customer={board.point}
          draftPolygon={board.draftPolygon}
          drawing={board.drawing || board.campaignDrawing}
          onPolygon={board.acceptPolygon}
        />
      </div>
    </div>
  );
}
